/**
 * Build iframe query string and collect documents from gameCards.
 */

/**
 * Build query params for iframe from gameCards (videos, card descriptions).
 */
export function buildGameCardsQueryParams(gameCards) {
  if (!gameCards?.length) return [];

  const params = [];
  gameCards.forEach((gameCard) => {
    if (!gameCard.slug) return;
    const slugKey = gameCard.slug.replace(/-/g, '_');

    if (gameCard.youtubeVideo) {
      params.push(`${slugKey}_video=${encodeURIComponent(gameCard.youtubeVideo)}`);
    }

    if (gameCard.cards?.length) {
      gameCard.cards.forEach((card) => {
        if (card.description) {
          params.push(`${slugKey}[]=${encodeURIComponent(card.description)}`);
        }
      });
    }
  });

  return params;
}

/**
 * Build full query string for iframe URL.
 */
export function buildIframeQueryString(gameCards) {
  const params = buildGameCardsQueryParams(gameCards);
  return params.length > 0 ? `?${params.join('&')}` : '';
}

/**
 * Collect all cheat sheet and worksheet documents from gameCards.
 */
export function collectDocumentsFromGameCards(gameCards) {
  const cheatSheets = [];
  const worksheets = [];

  if (!gameCards?.length) return { cheatSheets, worksheets };

  gameCards.forEach((gameCard) => {
    if (gameCard.cheatSheetDocuments) {
      cheatSheets.push(...gameCard.cheatSheetDocuments);
    }
    if (gameCard.workSheetDocuments) {
      worksheets.push(...gameCard.workSheetDocuments);
    }
  });

  return { cheatSheets, worksheets };
}

/**
 * Flatten all video sources from page data.
 */
export function collectVideoSources({ video, youtubeVideo, videos }) {
  return [
    ...(video?.video?.streamingUrl ? [video.video.streamingUrl] : []),
    ...(youtubeVideo ? youtubeVideo.split(',') : []),
    ...(videos?.length ? videos.map((v) => v.video?.streamingUrl).filter(Boolean) : []),
  ];
}
